'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap4Modal = require('react-bootstrap4-modal');

var _reactBootstrap4Modal2 = _interopRequireDefault(_reactBootstrap4Modal);

var _itemType = require('../itemType');

var _itemType2 = _interopRequireDefault(_itemType);

var _LinkEditor = require('../containers/LinkEditor');

var _LinkEditor2 = _interopRequireDefault(_LinkEditor);

var _propTypes3 = require('../propTypes');

var _SectionEditor = require('../containers/SectionEditor');

var _SectionEditor2 = _interopRequireDefault(_SectionEditor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var renderTitle = function renderTitle(navigationItemType) {
  if (navigationItemType === 'Link') {
    return 'Link properties';
  } else if (navigationItemType === 'Section') {
    return 'Section properties';
  }

  return '';
};

var renderForm = function renderForm(navigationItem, navigationItemType, onSave) {
  if (navigationItemType === 'Link') {
    return _react2.default.createElement(_LinkEditor2.default, { navigationItem: navigationItem, onSubmit: onSave });
  } else if (navigationItemType === 'Section') {
    return _react2.default.createElement(_SectionEditor2.default, { navigationItem: navigationItem, onSubmit: onSave });
  }

  return null;
};

function itemIsValid(navigationItem, navigationItemType) {
  if (!navigationItem) {
    return false;
  }

  if (navigationItemType === 'Link' && !navigationItem.page_id) {
    return false;
  }

  if (!navigationItem.title || navigationItem.title.trim() === '') {
    return false;
  }

  return true;
}

var NavigationItemEditorModal = function NavigationItemEditorModal(_ref) {
  var navigationItem = _ref.navigationItem,
      onSave = _ref.onSave,
      onCancel = _ref.onCancel,
      isCommittingEditingNavigationItem = _ref.isCommittingEditingNavigationItem;

  var navigationItemType = void 0;
  if (navigationItem) {
    navigationItemType = (0, _itemType2.default)(navigationItem);
  }
  return _react2.default.createElement(
    _reactBootstrap4Modal2.default,
    { visible: !!navigationItem },
    _react2.default.createElement(
      'div',
      { className: 'modal-header' },
      _react2.default.createElement(
        'h5',
        { className: 'modal-title' },
        renderTitle(navigationItemType)
      )
    ),
    _react2.default.createElement(
      'div',
      { className: 'modal-body' },
      renderForm(navigationItem, navigationItemType, onSave)
    ),
    _react2.default.createElement(
      'div',
      { className: 'modal-footer' },
      _react2.default.createElement(
        'button',
        {
          type: 'button',
          className: 'btn btn-secondary',
          onClick: onCancel,
          disabled: isCommittingEditingNavigationItem
        },
        'Cancel'
      ),
      _react2.default.createElement(
        'button',
        {
          type: 'button',
          className: 'btn btn-primary',
          onClick: onSave,
          disabled: isCommittingEditingNavigationItem || !itemIsValid(navigationItem, navigationItemType)
        },
        'Save'
      )
    )
  );
};

NavigationItemEditorModal.propTypes = {
  navigationItem: _propTypes3.NavigationItemPropType,
  onSave: _propTypes2.default.func.isRequired,
  onCancel: _propTypes2.default.func.isRequired,
  isCommittingEditingNavigationItem: _propTypes2.default.bool.isRequired
};

exports.default = NavigationItemEditorModal;


//////////////////
// WEBPACK FOOTER
// ./~/cadmus-navbar-admin/lib/components/NavigationItemEditorModal.js
// module id = 411
// module chunks = 0